// src/hooks/useRouteMeta.js
import { useEffect } from "react";
import { db } from "@/firebase";
import { doc, getDoc } from "firebase/firestore";

// Helper: support either a plain string or { en, fr }
function pickText(field) {
  if (!field) return "";
  if (typeof field === "string") return field;
  if (typeof field === "object") {
    return field.en || field.fr || "";
  }
  return "";
}

export function useRouteMeta(routeName, fallback = {}) {
  useEffect(() => {
    if (!routeName) return;

    async function loadMeta() {
      try {
        const ref = doc(db, "MetaTags", routeName);
        const snap = await getDoc(ref);
        const data = snap.exists() ? snap.data() : fallback;

        const metaTitle =
          pickText(data.metaTitle) || pickText(fallback.metaTitle);
        const metaDescription =
          pickText(data.metaDescription) || pickText(fallback.metaDescription);
        const metaOgTitle =
          pickText(data.metaOgTitle) ||
          pickText(fallback.metaOgTitle) ||
          metaTitle;
        const metaOgDescription =
          pickText(data.metaOgDescription) ||
          pickText(fallback.metaOgDescription) ||
          metaDescription;
        const metaOgImage =
          data.metaOgImage || fallback.metaOgImage || "";

        // <title>
        if (metaTitle) {
          document.title = metaTitle;
        }

        // Helper for <meta> tags
        function setMeta(attrName, attrValue, content) {
          if (!content) return;
          let tag = document.querySelector(`meta[${attrName}="${attrValue}"]`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute(attrName, attrValue);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content);
        }

        setMeta("name", "description", metaDescription);
        setMeta("property", "og:title", metaOgTitle);
        setMeta("property", "og:description", metaOgDescription);
        setMeta("property", "og:image", metaOgImage);
      } catch (err) {
        console.error("Failed to load meta for route:", routeName, err);
      }
    }

    loadMeta();
    // fallback is usually a literal object; it's fine if this re-runs occasionally
  }, [routeName, JSON.stringify(fallback)]);
}
